<template>
	<div class="container-table">
		<ui-table :columns="tableColumns"
			:loading="loading"
			:select-column-menu="false"
			:data="contents"
			class="scroll-color"
			name="usersTeamsList"
			tr-component="marketing/erp/product/table-line"
			not-found-text="Não foi possível encontrar nenhuma Equipe"
			not-found-icon="fal fa-building"
		/>
	</div>
</template>

<script>
import { uiTable } from '@/components/ui'

export default {
	components: {
		uiTable,
	},

	props: {
		/**
		 * Conteúdo a ser renderizado na tabela
		 */
		contents: {
			type: Array,
			required: true
		},
		/**
		 * Insere o status de loading na tabela
		 */
		loading: {
			type: Boolean,
			required: false,
			default: false
		}
	},

	data() {
		return {
			tableColumns: [
				{
					title: 'Status',
				},
				{
					title: 'Empreendimento Facilita',
				},
				{
					title: 'Empreendimento ERP',
				},
				{
					title: 'Tipo de Disponibilidade',
				},
				{
					title: 'Tipo de Integração',
				},
				{ title: '' },
			],
		}
	}
}
</script>